import { useQuery } from 'react-query';
import { useFormActionNotifier } from 'hooks';
import { getResponseData } from 'utils/clients';
import { fetchConnectivity } from 'clients/connectivity';
import { ConnectivityFilters } from 'models/connectivity/filters';

type Options = {
  params: ConnectivityFilters;
  enabled: boolean;
}

export function useDeviceConnectivity({ params, enabled }: Options) {
  const { notifyError } = useFormActionNotifier();

  const queryResult = useQuery({
    queryKey: ['connectivity/devices', params],
    queryFn: async () => getResponseData(await fetchConnectivity(params)),
    cacheTime: Infinity,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onError: e => {
      notifyError(`Error while fetching devices connectivity: ${ (e as Error).message }`);
    },
    enabled,
  });

  return {
    isLoading: queryResult.isLoading,
    connectivity: queryResult.data || [],
  };
}